<template>
    <div>
        <vs-sidebar 
            v-if="!forDelivery"
            click-not-close 
            position-right 
            parent="body" 
            default-index="1" 
            color="primary" 
            class="add-new-data-sidebar items-no-padding" 
            spacer 
            v-model="responsiveSidebar"
            >
            <checkout-new-order-side-bar v-if="table" class="p-6" :tableId="table.table.id" @saved="onSaveNewOrder" @closeSidebar="closeSidebar" />
        </vs-sidebar>

        <div class="vx-row" id="">
            <div class="vx-col" :class="isSmallerScreen || forDelivery ? 'w-full' : 'w-9/12'">
                <!-- SEARCH -->
                <div class="flex mb-base">
                    <vs-input v-model.lazy="filter" icon-pack="feather" icon="icon-search" class="w-full" placeholder="Pesquisar" size="large" />
                    
                    <div style="position: relative" v-if="!forDelivery">
                        <transition name="slide-fade" mode="out-in">
                            <vs-chip transparent color="primary" class="chip" :key="productsOrder.length" v-if="isSmallerScreen"> 
                                {{ productsOrder.length }}
                            </vs-chip>
                        </transition>
                        <vs-button color="primary" type="border" icon-pack="feather" icon="icon-shopping-bag" class="ml-4 h-16" @click="toggleSidebar" v-if="isSmallerScreen">SACOLA</vs-button>
                    </div>
                </div>

                <!-- BREADCRUMB -->
                <div class="w-full mb-base">
                    <new-order-bread-crumb :navigation="navigation" @change="to => onChangeBreadCrumb(to)" v-show="!filter" />
                </div>
            
                    <div class="vx-row" v-if="!filteredProducts.length && filter.length < 3">
                        <!-- MENU -->
                        <template v-if="!navigation.menu.id && !navigation.pType.id">
                            <!--<div class="vx-col mb-base xs:w-full sm:w-6/12 md:w-4/12 lg:w-3/12 xl:w-2/12 cursor-pointer" v-if="!forDelivery">
                                <vs-button 
                                    color="warning" 
                                    class="w-full cards-items" 
                                    size="large"
                                    @click="modalTaxByPerson.visible = true">
                                    <vs-icon
                                        style="font-size: 32px"
                                        class="icon-back mr-2 text-white cursor-pointer"
                                        icon-pack="material-icons"
                                        icon="mic"/><br/>
                                    COUVERT ARTÍSTICO
                                </vs-button>
                            </div>-->
                            
                            <div class="vx-col mb-base xs:w-full sm:w-6/12 md:w-4/12 lg:w-3/12"
                                 :class="!forDelivery ? 'xl:w-2/12' : 'xl:w-3/12'"
                                 v-for="(menu, i) in Object.entries(localMenus)" 
                                 :key="i" 
                                 @click="selectMenu(menu[1])">
                                <div class="rounded-lg cards-items cursor-pointer"
                                    :style="`background-image: linear-gradient(45deg, ${menu[1].colors.a} 0%, ${menu[1].colors.b} 40%), url('${menu[1].image}')`">
                                    <p class="title-card font-bold" :style="`font-size: ${getCardFontSize(menu[1].description)}`"> {{ truncateText(menu[1].description) }} </p>
                                </div>           
                            </div>
                        </template>
                        <!-- PRODUCT TYPES -->
                        <template v-else-if="!navigation.pType.id">
                            <div 
                                class="vx-col mb-base xs:w-full sm:w-6/12 md:w-4/12 lg:w-3/12" 
                                :class="!forDelivery ? 'xl:w-2/12' : 'xl:w-3/12'"
                                v-for="(pType, i) in productTypesFromSelectedMenu" 
                                :key="i">
                                <div class="rounded-lg  cards-items cursor-pointer"
                                    @click="selectProductType(pType)"
                                    :style="`background-image: linear-gradient(45deg, ${selectedMenu.colors.a} 0%, ${selectedMenu.colors.b} 40%), url('${pType.image}')`">
                                    <p class="title-card font-bold" :style="`font-size: ${getCardFontSize(pType.description)}`"> {{ truncateText(pType.description) }} </p>
                                </div>           
                            </div>
                        </template>
                        <!-- PRODUCTS -->
                        <template v-else>
                            <div class="vx-col mb-base xs:w-full sm:w-6/12 md:w-4/12 lg:w-3/12" 
                                 :class="!forDelivery ? 'xl:w-2/12' : 'xl:w-3/12'"
                                 v-for="(product, i) in productsFromProductType" 
                                 :key="i">
                                <div class="rounded-lg cards-items cursor-pointer"
                                    @click="selectProduct(product)"
                                    :style="`background-image: linear-gradient(45deg, ${selectedMenu.colors.a} 0%, ${selectedMenu.colors.b} 40%), url('${product.image}')`">
                                    <p class="title-card font-bold" :style="`font-size: ${getCardFontSize(product.description)}`"> {{ truncateText(product.description) }} </p>
                                </div>           
                            </div>
                        </template>
                    </div>

                    <div v-else>
                        <div v-if="!filteredProducts.length && filter" class="flex justify-center"> NENHUM PRODUTO ENCONTRADO! </div>
                        <div class="vx-row" v-else>
                            <div class="vx-col mb-base xs:w-full sm:w-6/12 md:w-4/12 lg:w-3/12" 
                                :class="!forDelivery ? 'xl:w-2/12' : 'xl:w-3/12'"
                                v-for="(product, i) in filteredProducts" 
                                :key="i">
                                <div class="rounded-lg cards-items cursor-pointer"
                                    @click="selectProduct(product)"
                                    :style="`background-image: linear-gradient(45deg, #8c2119aa 0%, #8c2119aa 40%), url('${product.image}')`">
                                    <p class="title-card font-bold" :style="`font-size: ${getCardFontSize(product.description)}`"> {{ truncateText(product.description) }} </p>
                                    
                                </div>           
                            </div>
                        </div>
                    </div>
            </div>
            
            <div class="vx-col w-3/12 border border-solid border-grey rounded-lg p-4 shadow-drop checkout-without-sidebar" v-if="!isSmallerScreen && !forDelivery">
                <checkout-new-order-side-bar v-if="table" :tableId="table.table.id" @saved="onSaveNewOrder" />
            </div>
        </div>

        <vs-popup
            :title="`ADICIONAR ${(modalProductOption.productDescription || '').toUpperCase()}`"
            :active.sync="modalProductOption.visible"
            style="zIndex: 9999999;">
            <order-product-options
                :key="modalProductOption.productId"
                :product-description="modalProductOption.productDescription"
                :product-id="modalProductOption.productId"
                :table="table && table.table"
                @onClosePanel="toggleAddProductModal(false)"
                v-if="modalProductOption.productId"
            />
        </vs-popup>

        <vs-popup  
            title="ADICIONAR COUVERT"
            :active.sync="modalTaxByPerson.visible"
            style="zIndex: 9999999">
            <add-tax-by-person @close="() => modalTaxByPerson.visible = false" />
        </vs-popup>
    </div>
</template>

<script>
    import VuePerfectScrollbar from 'vue-perfect-scrollbar'
    import CheckoutNewOrderSideBar from './CheckoutNewOrderSideBar'
    import { mapState, mapActions, mapMutations, mapGetters } from 'vuex'
    import OrderProductOptions from '../product/OrderProductOptions'
    import NewOrderBreadCrumb from './BreadCrumb'
    import _misc from '@/assets/utils/misc.js'  
    import AddTaxByPerson from '../taxes/AddTaxByPerson.vue'
    
    const transparentLevel = 'cc';

    export default {
        props: {
            forDelivery : {
                type : Boolean,
                required : false
            },
            visible : Boolean,
            table : Object
        },

        components : {
            AddTaxByPerson,
            NewOrderBreadCrumb,
            OrderProductOptions,
            CheckoutNewOrderSideBar,
            VuePerfectScrollbar
        },

        data () {
            return {
                showSidebar : false,
                filter : '',
                navigation : {
                    menu : { id : '', description : '' },
                    pType : { id : '', description : '' }
                },
                modalProductOption : {
                    productId : '',
                    visible : false
                },
                modalTaxByPerson : {
                    visible : false
                }
            }
        },

        async mounted () {
            await this.fetchMenus();
            await this.fetchProductTypes();
        },

        watch : {
            visible (val) {
                if(!val) {
                    if(!val) {
                        this.localCleanUp()
                        this.showSidebar = false
                        this.cleanUp()
                        this.filter = ''
                    }
                    this.$emit('close', val)
                }
            }
        },

        computed : {
            responsiveSidebar : {
                get () {
                    if(!this.isSmallerScreen) {
                        return false
                    }
                    return this.showSidebar
                },
                set (val) {
                    if(this.isSmallerScreen && this.showSidebar == true)
                        this.showSidebar = false
                    else
                    this.showSidebar = val
                }

            },

            localMenus () {
                const productTypes = this.productTypes
                const menus  = this.menus
                let newMenus = {}
                if (!menus || !productTypes)
                    return {};
                menus.forEach(menu => {
                    const productTypeImage = productTypes.filter(a => a.menu == menu.id)
                    let menuImage = ''
                    let qtdProducts = 0
                    newMenus[menu.id] = {}

                    productTypeImage.forEach(p => {
                        if(p.products) {
                            const product = Object.entries(p.products)
                            qtdProducts += product.length
                            product.forEach(t => {
                                t[1].menuDescription  = _misc.removeSpecialChars(menu.description) 
                                t[1].pTypeDescription = _misc.removeSpecialChars(p.description)
                                if(t[1].image) {
                                    menuImage = t[1].image
                                }
                            })
                            if(!newMenus[menu.id].productType)
                                newMenus[menu.id].productType = []
                            newMenus[menu.id].productType.push({...p, ...{image: menuImage}})
                        }
                    })
                    
                    if(qtdProducts)
                        newMenus[menu.id] = {...(newMenus[menu.id] || {}), ...{ 
                            id : menu.id, 
                            description: menu.description,
                            image : menuImage,
                            colors : { a : `#b36560 `, b : `#8c2119${transparentLevel}` }
                            // colors : { a : `${randColor}${transparentLevel}`, b : `${this.incrementColor(randColor, 300)}${transparentLevel}` }
                        }}
                    else
                        delete newMenus[menu.id]
                })
                return newMenus || {}
            },

            filteredProducts () {
                const filterText = _misc.removeSpecialChars(this.filter)
                if (!filterText.length)
                    return [];
                const menus = Object.entries(this.localMenus)
                let filterResult = []
                menus.forEach(menu => {
                    const productType = menu[1].productType
                    if(productType)
                        productType.forEach(pType => {
                            if(pType.products){
                                const products = Object.entries(pType.products)
                                products.forEach(product => {
                                    const productDesc = _misc.removeSpecialChars(product[1].description)
                                    if((product[1].cod && product[1].cod.toString().includes(filterText)) || productDesc.indexOf(filterText) > -1 || product[1].menuDescription.indexOf(filterText) > -1 || product[1].pTypeDescription.indexOf(filterText) > -1)
                                        filterResult.push({ 
                                            description : product[1].description,
                                            image : product[1].image,
                                            id : product[1].id
                                        })
                                })
                            }
                        })
                })
                return filterResult;
            },

            products () {
                if(!this.navigation.menuId && !this.navigation.pType.id) 
                    return
            },

            selectedMenu () {
                const menu = Object.entries(this.localMenus).filter(a => a[1].id == this.navigation.menu.id)
                if(menu[0]) 
                    return menu[0][1]
                else return []
            },

            productTypesFromSelectedMenu () {
                const menu = this.selectedMenu
                
                if(menu.productType)
                    return menu.productType
                this.navigation.menu.id = ''
                return []
            },

            productsFromProductType () {
                const pTypes = this.productTypesFromSelectedMenu.find(a => a.id == this.navigation.pType.id)
                if(pTypes)
                    return Object.entries(pTypes.products).map(a => a[1])

                this.navigation.pType.id = ''
                return []
            },

            isSmallerScreen() {
                return this.$store.state.windowWidth < 1200
            },
            ...mapGetters('productType', { 'productTypes': 'activeProductsOnly', 'menus': 'companyMenus' }),
            ...mapState('order', ['productsOrder'])
        },

        methods : {
            closeSidebar () {
                this.showSidebar = false
            },
            onChangeBreadCrumb (to) {
                switch (to) {
                    case 0 :
                        this.localCleanUp()
                        break;
                    case 1 :
                        this.$set(this.navigation.pType, 'id', '')
                        break;
                    default :
                        this.backToMenus()
                        break;
                }
            },

            onSaveNewOrder () {
                this.localCleanUp()
                this.showSidebar = false
                this.$emit('saved')
            },

            localCleanUp() {
                this.navigation = {
                    menu : { id : '', description : '' },
                    pType : { id : '', description : '' }
                }
            },

            toggleAddProductModal (toggleTo) {
                this.modalProductOption.visible = toggleTo
            },

            toggleSidebar () {
                this.showSidebar = !this.showSidebar
            },

            selectProduct (product) {
                this.toggleAddProductModal(true)
                this.modalProductOption.productId = product.id
                this.modalProductOption.productDescription = product.description
            },

            truncateText (text) {
                if(text.length > 22) 
                    return `${text.substr(0, 22)}...`
                return text
            },

            getCardFontSize (text) {
                if(this.forDelivery) return '16px' 
                if(text.length > 10) return '18px'
                if(text.length > 8) return '20px'
                if(text.length > 6) return '22px'
                if(text.length > 4) return '24px'
                return '32px'
            },

            backToMenus () {
                const {navigation} = this
                console.log(navigation)
                if(navigation.menu.id && navigation.pType.id)
                    this.navigation.pType.id = null
                else if(navigation.menu.id)
                    this.navigation.menu.id = null
            },

            selectMenu (menu) {
                this.navigation.menu.id = menu.id
                this.navigation.menu.description = menu.description

                // Checking whether has only one pType
                const pTypes = this.productTypesFromSelectedMenu
                if(pTypes.length == 1) {
                    this.navigation.pType.id = pTypes[0].id
                    this.navigation.pType.description = pTypes[0].description
                }
            },

            selectProductType (pType) {
                this.navigation.pType.id = pType.id
                this.navigation.pType.description = pType.description
            },

            getRandomColor () {
                var letters = '0123456789ABCDEF';
                var color = '#';
                for (var i = 0; i < 6; i++) {
                    color += letters[Math.floor(Math.random() * 16)];
                }
                return color;
            },

            incrementColor (color, step) {
                var colorToInt = parseInt(color.substr(1), 16),                     
                    nstep = parseInt(step);                                         
                if(!isNaN(colorToInt) && !isNaN(nstep)){                            
                    colorToInt += nstep;                                            
                    var ncolor = colorToInt.toString(16);                           
                    ncolor = '#' + (new Array(7-ncolor.length).join(0)) + ncolor;   
                    if(/^#[0-9a-f]{6}$/i.test(ncolor)){                             
                        return ncolor;
                    }
                }
                return color;
            },

            ...mapActions('productType', ['fetchProductTypes', 'fetchMenus']),
            ...mapMutations('order', ['cleanUp'])
        }
    }
</script>

<style lang="scss">
    .chip {
        position: absolute;
        top: -10px;
        right: -15px;
        z-index: 1000;
    }

    .search {
        position: fixed;
        top: 0;
    }
    .cards-items {
        position: relative;
        background-position : center;
        background-repeat: no-repeat;
        background-size: 110%; 
        display: flex;
        justify-content: center;
        align-items: center;
        height: 160px; 
        // background-image: linear-gradient(45deg, #edf03caa 0%, #c4d372aa 40%)
        // box-shadow: 0 0 5px red;
    }
    .cards-items.not-mobile {
        height: 160px; 
        width: 180px;
    }
    .cards-items.mobile {
        height: 130px; 
        // width: 100%;
    }
    .cards-items.couvert-mobile {
        height: 80px; 
        width: 100%;
    }
    .title-card {
        flex: 0 0 0;
        // font-size: 32px;
        text-transform: uppercase;
        text-shadow: 1px 1px 2px black;
        -webkit-text-shadow: 0px -25px 51px -29px rgba(0,0,0,0.54);
        -moz-text-shadow: 0px -25px 51px -29px rgba(0,0,0,0.54);
        color: white;
    }

    .add-new-data-sidebar {
        .vs-sidebar {
            z-index: 99999;
            width: 400px;
            max-width: 90vw;

            .img-upload {
                margin-top: 2rem;

                .con-img-upload {
                    padding: 0;
                }

                .con-input-upload {
                    width: 100%;
                    margin: 0;
                }
            }
        }
    }

    .scroll-area--data-list-add-new {
        // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
        height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);
    }

    .checkout-without-sidebar {
        overflow: hidden;
        max-height: calc(100vh - 130px);
        min-height: calc(100vh - 130px);
    }
</style>